import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { initI18n } from "./i18n";

/**
 * Initialize i18n before rendering the app
 * This ensures translations are available immediately when components mount
 */
initI18n();

/**
 * Application Entry Point
 * Providers are now wrapped in App component
 */
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
